import { render, staticRenderFns } from "./OverdueExpire.vue?vue&type=template&id=180aa64e&"
import script from "./OverdueExpire.vue?vue&type=script&lang=js&"
export * from "./OverdueExpire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports